import EventsAPI from "../../../shared/modules/EventsAPI";
import PropTypes from "prop-types";
import React from "react";

export default class StyleProfile extends React.PureComponent {
  static propTypes = {"styleSurvey": PropTypes.object.isRequired};

  static desktopStyleProfileWindow (styleSurvey) {
    return (
      <div>
        <h2 className="styled_h5 mt0 center">
          My Style Profile
        </h2>
        <p className="styled_h5 relative  left title">
          Metal:
        </p>
        <div className="relative small metal-styles align-right right">
          {styleSurvey.metal}
        </div>
        <br />
        <p className="styled_h5 relative  left title">
          {styleSurvey.dontWear.length === 0
            ? "I wear:"
            : "I don't wear:"}
        </p>
        <div className="relative align-right right small ml16 jewelry-wear-list">
          {styleSurvey.dontWear.length === 0
            ? "Bracelets, Rings, Earrings, Necklaces"
            : styleSurvey.dontWear.join(", ")}
        </div>
        <br />
        <p className="styled_h5 relative  left title">
          Ring Size:
        </p>
        <div className="relative ring-size-list small align-right right">
          {styleSurvey.ringSizes.length === 0
            ? "None"
            : styleSurvey.ringSizes}
        </div>
        <a
          className="btn btn-secondary centered mt24 style-survey-cta style-profile-update-cta"
          href="/surveys/retake"
          onClick={() => EventsAPI.trackCustomerEvent("clicked_cta", "Update")} // eslint-disable-line react/jsx-no-bind
        >
          Update
        </a>
      </div>
    );
  }

  render () {
    const {styleSurvey} = this.props;
    return (
      <div className="style-profile mt24">
        <img className="sr-only" />
        <div className="style-profile-container">
          <div className="style-profile-window mt32">
            {this.constructor.desktopStyleProfileWindow(styleSurvey)}
          </div>
        </div>
      </div>
    );
  }
}
